
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class HighCloudyImageBadge extends Vue {
  @Prop({ default: false }) readonly highCloudyImage!: boolean;
  @Prop({ default: 'small' }) readonly size!: 'small' | 'large';

  get sizeClass() {
    return `high-cloudy-image-badge--${this.size}`;
  }
}
